import React, { useState, useEffect } from 'react';
import './styles/StudentZone.css';

const StudentZone = () => {
  const [triviaAnswered, setTriviaAnswered] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const checkTrivia = (optionIndex, isCorrect) => {
    if (triviaAnswered) return;

    setSelectedAnswer(optionIndex);
    setTriviaAnswered(true);
    setShowResult(true);

    // Reset after 5 seconds
    setTimeout(() => {
      setTriviaAnswered(false);
      setSelectedAnswer(null);
      setShowResult(false);
    }, 5000);
  };

  const triviaOptions = [
    { text: 'Shringara', isCorrect: false },
    { text: 'Karuna', isCorrect: false },
    { text: 'Raudra', isCorrect: false },
    { text: 'Bhakti', isCorrect: true }
  ];

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.feature-card');
    animateElements.forEach(el => {
      el.classList.add('fade-in');
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="student-zone" className="student-zone">
      <div className="container">
        <h2 className="section-title">Student Zone</h2>
        <p className="section-subtitle">Your personal learning sanctuary</p>

        <div className="student-features">
          {/* <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Arangetram Tracker</h3>
            <p>Track your progress through the sacred journey to your debut performance</p>
            <div className="progress-demo">
              <h4>Your Progress:</h4>
              <ul>
                <li>✓ Items learned: 3/8</li>
                <li>✓ Attendance: 85%</li>
                <li>✓ Theory notes: Complete</li>
                <li>⏳ Performance readiness: In Progress</li>
              </ul>
            </div>
          </div> */}

          <div className="feature-card">
            <div className="feature-icon">🧠</div>
            <h3>Trivia Playground</h3>
            <p>Test your knowledge and earn badges while having fun</p>
            <div className="badges">
              <span className="badge">Rasa Ruler ✓</span>
              <span className="badge">Nattuvangam Ninja ✓</span>
            </div>
            <div className="trivia-demo">
              <h4>Today's Challenge:</h4>
              <p><strong>Which rasa is characterized by the emotion of devotion and spiritual love?</strong></p>
              <div className="trivia-options">
                {triviaOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`trivia-option ${
                      selectedAnswer === index
                        ? option.isCorrect
                          ? 'correct'
                          : 'incorrect'
                        : triviaAnswered && option.isCorrect
                        ? 'correct'
                        : ''
                    }`}
                    onClick={() => checkTrivia(index, option.isCorrect)}
                    disabled={triviaAnswered}
                  >
                    {option.text}
                  </button>
                ))}
              </div>
              {showResult && (
                <div id="trivia-result">
                  {selectedAnswer !== null && triviaOptions[selectedAnswer].isCorrect ? (
                    <div className="result-success">
                      🎉 Correct! Bhakti rasa represents devotion and spiritual love. You earned 10 points!
                    </div>
                  ) : (
                    <div className="result-error">
                      ❌ Not quite right. Bhakti rasa represents devotion and spiritual love. Try again next time!
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">⭐</div>
            <h3>Student Wall of Fame</h3>
            <p>Celebrate achievements and share your Kalavaanya journey</p>
            <div className="wall-of-fame">
              <div className="testimonial">
                <p>"Kalavaanya has transformed my understanding of dance. The sisters create a nurturing environment where tradition comes alive."</p>
                <span>- Priya S., Advanced Student</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudentZone;